const RUNNER_URL_KEY = 'mermadic_runner_url';

const env = (key) => window._env_?.[key] || process.env[key] || '';

// Shared / "default" runner base URL for THIS environment (prod vs QA). Env-driven
// so the QA UI recognises its own qa-job default runner instead of always comparing
// against the prod job.mermadicrunner.com URL.
export const DEFAULT_RUNNER_URL = env('REACT_APP_RUNNER_API') || 'https://job.mermadicrunner.com/job-runner';

const LOCAL_AUTH_API = 'http://localhost:80/authentication';

const isLocalTest = () => env('REACT_APP_AUTH_API') === LOCAL_AUTH_API;

// Debug: log resolved URLs on module load
console.log('[Config] window._env_:', window._env_);
console.log('[Config] process.env REACT_APP_AUTH_API:', process.env.REACT_APP_AUTH_API);
console.log('[Config] env() REACT_APP_AUTH_API:', env('REACT_APP_AUTH_API'));
console.log('[Config] isLocalTest:', isLocalTest());
console.log('[Config] RUNNER_API env:', env('REACT_APP_RUNNER_API'));
console.log('[Config] localStorage runner_url:', localStorage.getItem(RUNNER_URL_KEY));

const config = {
    AUTH_API: env('REACT_APP_AUTH_API'),
    MASTER_API: env('REACT_APP_MASTER_API') || 'https://master.mermadicrunner.com/mermadic-master',

    COGNITO_CLIENT_ID: env('REACT_APP_COGNITO_CLIENT_ID'),
    COGNITO_REGION: env('REACT_APP_COGNITO_REGION'),
    USER_POOL: env('REACT_APP_USER_POOL'),

    // Cloudflare Turnstile site key. Empty means no captcha, which keeps local and
    // QA usable without keys; the APIs make the same choice from their secret.
    TURNSTILE_SITE_KEY: env('REACT_APP_TURNSTILE_SITE_KEY'),

    get RUNNER_API() {
        if (isLocalTest()) return env('REACT_APP_RUNNER_API') || '';
        return localStorage.getItem(RUNNER_URL_KEY)
            || env('REACT_APP_RUNNER_API')
            || '';
    },
    get RUNNER_SWAGGER() {
        if (isLocalTest()) return env('REACT_APP_RUNNER_SWAGGER') || '';
        const runnerUrl = localStorage.getItem(RUNNER_URL_KEY);
        if (runnerUrl) return `${runnerUrl}/openapi.json`;
        return env('REACT_APP_RUNNER_SWAGGER') || '';
    },
};

export const setRunnerUrl = (url) => {
    // No-op in local test — the .env value is always used directly.
    if (isLocalTest()) return;
    localStorage.setItem(RUNNER_URL_KEY, url);
};

export const clearRunnerUrl = () => {
    localStorage.removeItem(RUNNER_URL_KEY);
};

export const isDefaultCluster = () => {
    const stored = localStorage.getItem(RUNNER_URL_KEY);
    if (!stored) return true;
    return stored === DEFAULT_RUNNER_URL;
};

export default config;
